/**
 * Legal entity operating the RM Digital Solutions platform.
 *
 * Shown in the legal notice (/impressum) and in the portal footer. Keep in
 * sync with the Firmenbuch and with https://www.rubblemaster.com/de/impressum.
 * Language-dependent wording (legal form, country, chamber, ...) lives in the
 * "impressum" block of public/locales/{de,en}/translation.json.
 */
export const companyInfo = {
  name: 'RUBBLE MASTER HMH GmbH',
  street: 'Im Südpark 196',
  city: '4030 Linz',
  phone: '+43 732 73 71 17 - 0',
  phoneHref: 'tel:+437327371170',
  /** Digital Office: contact for the platform and for vulnerability reports (see security.txt). */
  email: 'do@rubblemaster.com',
  registerNumber: 'FN 316865 d',
  registerCourt: 'Landesgericht Linz',
  vatId: 'ATU 64589118',
  managingDirectors: 'Rudolf Schöflinger, Bernhard Fischereder',
  wkoMemberNumber: '3189229',
  websiteUrl: 'https://www.rubblemaster.com',
  /** RFC 9116 security contact file, source: Frontend/public/.well-known/security.txt */
  securityTxtPath: '/.well-known/security.txt',
};
